import * as Sentry from '@sentry/react';
import { redactSecrets, redactString } from '@/utils/redactSecrets';

Sentry.init({
  dsn: 'https://41db5d99687d781ed8d18d9b7e419a60@o4511490641952768.ingest.us.sentry.io/4511490643656704',
  release: import.meta.env.VITE_APP_VERSION ?? 'dev',
  debug: false,
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.replayIntegration(),
    Sentry.browserTracingIntegration(),
    Sentry.consoleLoggingIntegration({ levels: ['error'] }),
  ],
  enableLogs: true,
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: import.meta.env.PROD ? 1 : 0,
  // Los `console.error(err)` de axios llevan el token de sesión: se censura en
  // los logs de consola y en los breadcrumbs de los eventos de error.
  beforeSendLog: (log) => {
    log.message = redactString(log.message);
    if (log.attributes) redactSecrets(log.attributes);
    return log;
  },
  beforeSend: (event) => redactSecrets(event),
});
